var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-audit{stroke-width:1.8px;}.b-audit{stroke:none;}.c-audit{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27 -395)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a-audit",
    transform: "translate(39 400)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b-audit",
    d: "M0,0H6A2,2,0,0,1,8,2V16a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c-audit",
    d: "M1.8.9H6A1.1,1.1,0,0,1,7.1,2V14.2a.9.9,0,0,1-.9.9H1.8a.9.9,0,0,1-.9-.9V1.8A.9.9,0,0,1,1.8.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a-audit",
    transform: "translate(27 404)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b-audit",
    d: "M2,0H9A0,0,0,0,1,9,0V12a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c-audit",
    d: "M2,.9H7.2a.9.9,0,0,1,.9.9v8.4a.9.9,0,0,1-.9.9H1.8a.9.9,0,0,1-.9-.9V2A1.1,1.1,0,0,1,2,.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a-audit",
    transform: "translate(33 395)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b-audit",
    d: "M2,0H6A2,2,0,0,1,8,2V21a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c-audit",
    d: "M2,.9H6A1.1,1.1,0,0,1,7.1,2V19.2a.9.9,0,0,1-.9.9H1.8a.9.9,0,0,1-.9-.9V2A1.1,1.1,0,0,1,2,.9Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.98f78991.svg";
export { ForwardRef as ReactComponent };